import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { Container, Form } from 'react-bootstrap';
import { formatDate, formatWeek, getWeekNumber, sumMoney, displayStoredDate, partyLabel, transactionStatus, formatAmount } from '../../../helper';
import Select from '../../../Components/PCSelect';
import axios from "axios";
import Swal from "sweetalert2";
import RemoveIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';
import SaleDeviceAF from '../../../Report/SaleDevice/SaleDeviceAF';
import PhoneClinicGrid from '../../../Components/PhoneClinicGrid';
import RowActions from '../../../Components/PhoneClinicGrid/RowActions';
import StatusChip from '../shared/StatusChip';
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES, ToggleSwitch, QTY_INPUT } from '../shared/txStyles';

import AmountInput from '../../../Components/AmountInput';
import PageHeader from '../shared/PageHeader';
import withRouter from '../../../helper/withRouter';
import { recordOpened, recordClosed, recordParamChanged, recordNotFound } from '../../../helper/recordLinks';
import OwnEntityField from '../../../Components/OwnEntityField';
import { defaultOwnId } from '../../../helper/identity';
import { warehouseName } from '../../../helper/entityNames';

const BASE_PATH = '/admin/sale-item-wh';   // + '/<PUBLIC_ID>' opens one record (record links, Phase B)

class WarehouseItemSale extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The user's own warehouse this form works for (Phase 2): picked at the top when they have several.
            OWN_ID: defaultOwnId('warehouse', BASE_PATH),
            addSale: false,
            SaleList: [],
            ItemList: [],


            Customer: "",
            SALE_TO_TYPE: "Customer",
            Date: formatDate(new Date().toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],

            InventoryList: [],
            EMAIL_TO: "",
            isEdit: false,
            ShopList: [],
            AllWareHouseList: [],
            SaleToShop: "",
            SALE_INV: "",
            RevokeItems: [],
            SALE_DATE_RAW: getWeekNumber(new Date()),


            rateEditable: -1,
            quantityEditable: -1,
            editObj: {
                idx: "",
                label: "",
                value: ""
            }
        };
        this.gridRef = React.createRef(null);
    }


    // componentDidMount() {
    //     this.getSaleInvoice()
    //     this.getInventory()
    //     this.getShopList()
    // }


    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.PC_SP_ID,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList })
    }

    async getSaleInvoice(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_WH_ID: this.ownId(),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset,
        };
        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWHItemSale.php`, formData);
        let SaleData = getAllSale.data
        let SaleList = []
        if (SaleData.success === 1) {
            SaleList = SaleData.data
            pagination.totalItems = parseInt(SaleData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ SaleList })
        this.props.toggleLoader(false)
    }


    /* Always the CURRENT list and prices (T1.75): it used to be kept in a module-level cache
     * that was never cleared, so a price changed in Items / Warehouse Inventory showed only after a
     * full page reload (signing out), and switching the working shop / warehouse kept the first
     * one's list. Loaded once per form (Add, opening a record, changing the shop). */
    async getInventory() {
        let formData = {
            PC_WH_ID: this.ownId()
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getAllWarehouseInventory.php`, formData);
        let serviceData = getAllInventory.data
        let ItemList = []
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                ItemList.push({
                    'label': `${element.DEVICE_ID || ""} ${element.INV_ITEM_NAME}`,
                    'value': element.INV_ID + "||" + element.INV_ITEM_NAME,
                    'id': element.INV_ID
                })
            }
        }
        this.setState({ InventoryList, ItemList })
    }

    hanldeAddSale() {
        this.setState({ addSale: true })
        this.getInventory()
        this.getShopList()
    }

    handleSearchgridData() {

    }

    /* ── Own warehouse (Phase 2, 2026-11-02) ──
     * A saved record works with ITS warehouse (set when it opens); a new one with the warehouse picked at
     * the top (OwnEntityField — only the user's own; one warehouse: shown, locked). */
    ownId() {
        return this.recordOwner || this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    // A different warehouse for the new record: its stock / vendors are reloaded and items already
    // added are cleared, so nothing from another warehouse is carried over.
    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id), AddedItemList: [] }, () => this.getInventory());
    }

    /* ── Per-record links: /admin/sale-item-wh/<PUBLIC_ID> ── */
    componentDidMount() {
        const pid = this.props.params?.publicId;
        if (pid) this.openByPublicId(pid);
    }

    componentDidUpdate(prevProps) {
        // The warehouse's name for the printed invoice (Phase 2: it used to say "Mobile Shop").
        const wh = this.ownId();
        if (wh && wh !== this.servedByFor) { this.servedByFor = wh; warehouseName(wh).then(servedBy => this.setState({ servedBy })); }
        recordParamChanged(this, prevProps, (pid) => this.openByPublicId(pid), () => this.handleExit());
    }

    // The record behind a link, from the same list endpoint with the server applying the signed-in
    // user's scope (only this shop's / warehouse's own records) — then the same form the list opens.
    async openByPublicId(pid) {
        this.openPid = pid;
        this.props.toggleLoader(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWHItemSale.php`, {
                PC_WH_ID: this.ownId() || 0, PUBLIC_ID: pid,
            });
            const row = res.data?.success === 1 ? res.data.data[0] : null;
            this.props.toggleLoader(false);
            if (!row) return recordNotFound(this, BASE_PATH);
            this.recordOwner = String(row.SALE_FROM);
            await this.handleUpdateSale(row);
        } catch (error) {
            this.props.toggleLoader(false);
            console.error('openByPublicId error:', error);
            recordNotFound(this, BASE_PATH);
        }
    }

    // The list's view / edit button: the same form as before, and the record's link in the address bar.
    openFromList(row) {
        recordOpened(this, BASE_PATH, row.PUBLIC_ID);
        this.recordOwner = String(row.SALE_FROM);
        this.handleUpdateSale(row);
    }

    handleUpdateSale(historyRow) {
        this.getInventory()
        let SaleData = historyRow
        let Customer = SaleData.SALE_CUSTOMER;
        let shpValue = { value: Customer, label: SaleData.SALE_TO }
        // if (SaleData.SALE_TO_TYPE === "Shop") {
        //     let filterShopName = ShopList.filter(x => +x.value === +SaleData.SALE_CUSTOMER)?.[0]
        //     if (filterShopName) {
        //         shpValue = filterShopName
        //     }
        // }

        this.setState({
            isEdit: true,
            addSale: true,
            Customer: Customer,
            SaleToShop: shpValue,
            SALE_TO_TYPE: SaleData.SALE_TO_TYPE,
            Date: formatDate(SaleData.SALE_DATE),
            Description: SaleData.SALE_DESCRIPTION,
            AddedItemList: JSON.parse(SaleData.SALE_ITEM),
            SALE_INV: SaleData.SALE_INV,
            SALE_DATE_RAW: getWeekNumber(new Date(SaleData.SALE_DATE))
        })


    }

    handleChangeTotalRecords() {

    }

    handleChangePagination() {

    }

    handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item, InventoryList } = this.state;
        switch (fieldName) {
            case 'ItemName':
                let findInventory = InventoryList.filter(x => x.INV_ID === evt.id)?.[0]
                Item['ItemName'] = evt
                Item['ItemRate'] = parseFloat(findInventory.PC_WH_ITEM_SELL_RATE).toFixed(2)
                Item['ItemAmount'] = parseFloat(findInventory.PC_WH_ITEM_SELL_RATE).toFixed(2)
                Item['ItemIMEI'] = findInventory.INV_BARCODE
                Item['ItemDesc'] = findInventory.INV_DESC
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                break;

            case 'ItemDisType':
                Item['ItemDisType'] = evtA
                if (evtA === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;
            case 'ItemQuantity':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((evt.target.value * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((evt.target.value * Item['ItemRate']) - ((evt.target.value * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;
            case 'ItemRate':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * evt.target.value) - Item['ItemDisc']).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * evt.target.value) - ((Item['ItemQuantity'] * evt.target.value) * (Item['ItemDisc'] / 100))).toFixed(2)
                }
                break;

            case 'ItemDisc':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - evt.target.value).toFixed(2)
                } else {
                    Item['ItemAmount'] = parseFloat((Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (evt.target.value / 100))).toFixed(2)
                }
                break;

            case 'ItemIMEI':
                // let findInventory = InventoryList.filter(x => x.PC_ITEM_BARCODE === evt.target.value || x.PC_ITEM_BARCODE === evt.target.value)?.[0]
                Item[fieldName] = evt.target.value
                break;

            default:
                Item[fieldName] = evt.target.value
                break;

        }
        this.setState({ Item })
    }


    handleValidateItem(Item) {
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select Item',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseFloat(Item.ItemRate).toFixed(2) <= 0.00) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }
        return true
    }

    handleAddItem() {
        let { Item, AddedItemList } = this.state
        if (!this.handleValidateItem(Item)) return
        let checkIfItemAvailable = AddedItemList.filter(x => x.ItemName.id === Item.ItemName.id)
        let CheckIndex = AddedItemList.findIndex(x => x.ItemName.id === Item.ItemName.id);
        if (checkIfItemAvailable.length > 0) {
            let AddedItemContent = checkIfItemAvailable[0]
            let CalculatedQuantity = parseInt(AddedItemContent['ItemQuantity']) + parseInt(Item['ItemQuantity']);
            AddedItemList[CheckIndex]['ItemDesc'] = Item['ItemDesc'];
            AddedItemList[CheckIndex]['ItemDisc'] = Item['ItemDisc'];
            AddedItemList[CheckIndex]['ItemDisType'] = Item['ItemDisType'];
            AddedItemList[CheckIndex]['ItemRate'] = Item['ItemRate'];
            AddedItemList[CheckIndex]['ItemQuantity'] = CalculatedQuantity;

            if (Item['ItemDisType'] === 'number') {
                Item['ItemAmount'] = parseFloat((CalculatedQuantity * Item['ItemRate']) - Item['ItemDisc']).toFixed(2)
            } else {
                Item['ItemAmount'] = parseFloat((CalculatedQuantity * Item['ItemRate']) - ((CalculatedQuantity * Item['ItemRate']) * (Item['ItemDisc'] / 100))).toFixed(2)
            }

            AddedItemList[CheckIndex]['ItemAmount'] = parseFloat(Item['ItemAmount']).toFixed(2);
            this.setState({ AddedItemList })
        } else {
            let UpdateItemList = [Item].concat(AddedItemList)
            this.setState({ AddedItemList: UpdateItemList })
        }
        let RefreshItem = {
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemDisc: 0,
            ItemAmount: 0,
            ItemDisType: "number"
        }
        this.setState({
            Item: RefreshItem
        })

    }

    handleChange(fieldName, evt) {
        let value
        switch (fieldName) {
            case 'SaleToShop':
                value = evt
                break;
            case 'Date':
                value = evt.target.value;
                this.setState({ SALE_DATE_RAW: getWeekNumber(new Date(evt.target.value)) })
                break;
            default:
                value = evt.target.value
                break;
        }
        this.setState({
            [fieldName]: value
        })
    }

    ValidateInvoice() {
        let { SALE_TO_TYPE } = this.state;

        if (SALE_TO_TYPE === "Customer" && this.state.Customer === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please Enter Customer',
                'error'
            )
            return false
        }

        if (SALE_TO_TYPE === "Shop" && this.state.SaleToShop === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please select Shop',
                'error'
            )
            return false
        }

        if (this.state.AddedItemList.length === 0) {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please Add atleast 1 Item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSaveInvoice() {
        this.props.toggleLoader(true)
        if (!this.ValidateInvoice()) return
        let { SALE_TO_TYPE } = this.state
        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: this.ownId(),
            SALE_CUSTOMER: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.value,
            SALE_TO_TYPE: SALE_TO_TYPE,
            SALE_TO_LABEL: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.label,
            SALE_DATE: this.state.Date,
            SALE_DESCRIPTION: this.state.Description,
            SALE_WEEK: this.state.SALE_DATE_RAW,
            SALE_TOTAL_AMT: this.renderTotalAmount(),
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            SALE_INV: this.state.SALE_INV,
            RevokeItems: JSON.stringify(this.state.RevokeItems)
        }

        let mVarFolder = 'PCAddWHSale';
        if (this.state.isEdit) { mVarFolder = 'PCEditWHSale'; }
        console.log('formData', formData)
        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/${mVarFolder}.php`, formData);
        this.props.toggleLoader(false)
        if (getSaleInvoiceResult.data.status === 200) {
            Swal.fire(
                'Success',
                getSaleInvoiceResult.data.message,
                'success'
            )
            recordClosed(this, BASE_PATH);
            this.setState({
                addSale: false,
                // ItemList: [],
                Customer: "",
                SALE_TO_TYPE: "Customer",
                Warehouse: {},
                Date: formatDate(new Date().toDateString()),
                Description: "",

                Item: {
                    ItemName: "",
                    ItemIMEI: "",
                    ItemDesc: "",
                    ItemRate: 0,
                    ItemQuantity: 0,
                    ItemDisc: 0,
                    ItemAmount: 0,
                    ItemDisType: "number"
                },
                AddedItemList: [],
                isEdit: false,
                RevokeItems: [],
                SaleToShop: "",
            })
            this.getSaleInvoice()
        } else {
            Swal.fire(
                'Error',
                getSaleInvoiceResult.data.message,
                'error'
            )
        }
    }

    handleValidate() {
        if (this.state.EMAIL_TO === "") {
            Swal.fire(
                'Error',
                'Please Enter Email Address',
                'error'
            )
            return false
        }
        return true
    }

    async handleSendEmail() {

        if (!this.handleValidate()) return

        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: this.ownId(),
            SALE_CUSTOMER: this.state.Customer,
            // SALE_WAREHOUSE: this.state.Warehouse.value,
            SALE_DATE: this.state.Date,
            SALE_DESCRIPTION: this.state.Description,
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            EMAIL_TO: this.state.EMAIL_TO
        }
        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}mail/SendMail.php`, formData);
        if (getSaleInvoiceResult.data.status === 201) {
            Swal.fire(
                'Success',
                'Email has been send!!',
                'success'
            )
        }
    }

    handleExit() {
        recordClosed(this, BASE_PATH);
        this.recordOwner = null;
        this.setState({
            addSale: false,
            // ItemList: [],
            Customer: "",
            SALE_TO_TYPE: "Customer",
            Warehouse: {},
            Date: formatDate(new Date().toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            isEdit: false,
            RevokeItems: [],
            SaleToShop: "",
        })
    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return parseFloat(Price).toFixed(2)
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleEnterImei(evnt) {
        if (evnt.key === 'Enter') {
            let { Item, InventoryList } = this.state;

            let FilterItem = InventoryList.filter(x => x.INV_BARCODE === Item.ItemIMEI)
            if (FilterItem.length > 0) {

                Item['ItemName'] = {
                    'label': `${FilterItem[0].DEVICE_ID || ""} ${FilterItem[0].INV_ITEM_NAME}`,
                    'value': FilterItem[0].INV_ID + "||" + FilterItem[0].INV_ITEM_NAME,
                    'id': FilterItem[0].INV_ID
                }
                Item['ItemDesc'] = FilterItem[0].INV_DESC
                Item['ItemRate'] = parseFloat(FilterItem[0].PC_WH_ITEM_SELL_RATE)
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                Item['ItemAmount'] = parseFloat((1 * FilterItem[0].PC_WH_ITEM_SELL_RATE) - ((1 * FilterItem[0].PC_WH_ITEM_SELL_RATE) * (0 / 100))).toFixed(2)
            }
            this.setState({ Item }, () => { this.handleAddItem() })
        }

    }

    handleRemove(index, itemObj) {
        if (this.state.isEdit) {
            let { RevokeItems } = this.state;
            // InventoryList.push({
            //     'ItemName': itemObj.ItemName.display,
            //     'ItemQuantity': itemObj.ItemIMEI,
            //     'ItemDesc': itemObj.ItemName.ItemBrand,
            //     'ItemType': itemObj.ItemName.ItemType,
            //     'ItemDesc': itemObj.ItemDesc,
            //     'ItemSellRate': itemObj.ItemAmount
            // })

            RevokeItems.push(itemObj.ItemName)
            // ItemList.push(itemObj.ItemName)
            this.setState({ RevokeItems })
        }
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }

    handleEditItems(index, fieldName, currntValue, evt) {
        evt.preventDefault();
        let editObj = {
            idx: index,
            label: fieldName,
            value: currntValue
        }
        let otherName = fieldName === "ItemRate" ? "quantityEditable" : "rateEditable"
        let stateName = fieldName === "ItemRate" ? "rateEditable" : "quantityEditable"
        this.setState({ [stateName]: index, [otherName]: -1, editObj })
    }

    handleChangeEditableItem(evt) {
        let { editObj } = this.state;
        editObj[evt.target.name] = evt.target.value
        this.setState({ editObj })
    }

    handleValidateUpdateItem(Item) {
        if (Item.label === "ItemRate" && (Item.value === '' || parseFloat(Item.value).toFixed(2) <= 0.00)) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.label === "ItemQuantity" && (Item.value === '' || parseInt(Item.value) <= 0)) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }
        return true
    }

    handleUpdateEditableItem(applyChange, evnt) {
        let { editObj, AddedItemList } = this.state;
        switch (applyChange) {
            case "key_press":
                if (evnt.key === 'Enter') {
                    if (!this.handleValidateUpdateItem(editObj)) return;
                    AddedItemList[editObj.idx][editObj.label] = editObj.value;
                    let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                    if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                    } else {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                    }
                    let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                    this.setState({ [stateName]: -1, AddedItemList })
                }
                break;

            default:
                if (!this.handleValidateUpdateItem(editObj)) return;
                AddedItemList[editObj.idx][editObj.label] = editObj.value;
                let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                } else {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                }
                let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                this.setState({ [stateName]: -1, AddedItemList })
                break;
        }
    }

    async handleDeleteSale(PC_WHS_ID) {
        Swal.fire({
            title: 'Do you want to delete sale record ?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.props.toggleLoader(true)
                let formData = {
                    PC_WHS_ID: PC_WHS_ID,
                    PC_WHS_WHID: this.ownId(),
                }

                try {
                    let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/sale/DeleteWhSale.php`, formData);
                    this.props.toggleLoader(false)
                    if (getSaleInvoiceResult.data.status === 200) {
                        Swal.fire(
                            'Success',
                            getSaleInvoiceResult.data.message,
                            'success'
                        )
                        this.getSaleInvoice()
                    } else {
                        Swal.fire(
                            'Error',
                            getSaleInvoiceResult.data.message,
                            'error'
                        )
                    }
                } catch (error) {
                    this.props.toggleLoader(false)
                }
            }
        })

    }


    render() {
        const { addSale } = this.state;
        let { Item } = this.state;

        if (!addSale) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        ref={this.gridRef}
                        title="ITEM SALE"
                        buttonLabel="Add sale"
                        onClickButton={this.hanldeAddSale.bind(this)}
                        getData={this.getSaleInvoice.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "SALE TO", isHidden: false },
                            { label: "STATUS", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Columns follow the shared sale/purchase standard:
                            DATE | SALE TO or PURCHASE FROM as "Name (Type)" | DEVICE (device screens) | STATUS | TOTAL PRICE. */}
                        {this.state.SaleList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.SALE_DATE)}</TableCell>
                                <TableCell>{partyLabel(row.SALE_TO, row.SALE_TO_TYPE)}</TableCell>
                                <TableCell><StatusChip label={transactionStatus(row, 'sale')} /></TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.SALE_TOTAL_AMT)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.openFromList.bind(this, row) },
                                        { type: 'delete', onClick: this.handleDeleteSale.bind(this, row.SALE_ID) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Sale By Warehouse" right={<><ToggleSwitch
                        options={['Customer', 'Shop']}
                        value={this.state.SALE_TO_TYPE}
                        onChange={val => this.setState({ SALE_TO_TYPE: val })}
                    /></>} style={{ margin: "0 0 16px" }} />

                {/* The warehouse this record is for (Phase 2): own only; locked once saved. */}
                <OwnEntityField kind="warehouse" screen={BASE_PATH} value={this.ownId()} disabled={!!this.recordOwner || !!this.state.isEdit} onChange={this.handleOwnChange.bind(this)} />
                {/* Input Card */}
                <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr', gap: 16, marginBottom: 16 }}>
                        <div>
                            <label style={LABEL}>{this.state.SALE_TO_TYPE}</label>
                            {this.state.SALE_TO_TYPE === 'Customer'
                                ? <input style={INPUT} disabled={this.state.isEdit} value={this.state.Customer} onChange={this.handleChange.bind(this, 'Customer')} />
                                : <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" isDisabled={this.state.isEdit} value={this.state.SaleToShop} options={this.state.ShopList} onChange={this.handleChange.bind(this, 'SaleToShop')} />
                            }
                        </div>
                        <div>
                            <label style={LABEL}>Date</label>
                            <input type="date" style={INPUT} disabled={this.state.isEdit} value={this.state.Date} onChange={this.handleChange.bind(this, 'Date')} />
                        </div>
                        <div>
                            <label style={LABEL}>Description</label>
                            <input style={INPUT} value={this.state.Description} onChange={this.handleChange.bind(this, 'Description')} />
                        </div>
                    </div>
                    {/* Item entry */}
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 2fr 1fr 0.7fr', gap: 12, marginBottom: 12 }}>
                        <div>
                            <label style={LABEL}>Item</label>
                            <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={Item['ItemName']} options={this.state.ItemList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                        </div>
                        <div>
                            <label style={LABEL}>IMEI / Barcode</label>
                            <input style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleEnterImei.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                        </div>
                        <div>
                            <label style={LABEL}>Rate</label>
                            <AmountInput plain style={INPUT} value={Item['ItemRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemRate')} />
                        </div>
                        <div>
                            <label style={LABEL}>Qty.</label>
                            <input type="number" style={INPUT} value={Item['ItemQuantity']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemQuantity')} />
                        </div>
                    </div>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '3fr 1fr auto auto', gap: 12, alignItems: 'flex-end' }}>
                        <div>
                            <label style={LABEL}>Item Description</label>
                            <input style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                        </div>
                        <div>
                            <label style={LABEL}>Discount</label>
                            <AmountInput plain style={INPUT} value={Item['ItemDisc']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDisc')} />
                        </div>
                        <div>
                            <label style={LABEL}>Type</label>
                            <ToggleSwitch
                                options={['£', '%']}
                                value={Item['ItemDisType'] === 'number' ? '£' : '%'}
                                onChange={val => this.setState(prev => ({ Item: { ...prev.Item, ItemDisType: val === '£' ? 'number' : 'percent' } }))}
                            />
                        </div>
                        <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                    </div>
                </div>

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small" className="pc-card-table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>RATE</TableCell>
                                <TableCell style={COL_HEAD}>QTY</TableCell>
                                <TableCell style={COL_HEAD}>DISCOUNT</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                <TableCell style={COL_HEAD}>ACTION</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{ItemDetails.ItemName?.label}</TableCell>
                                    <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                    <TableCell onDoubleClick={this.handleEditItems.bind(this, idx, 'ItemRate', ItemDetails.ItemRate)}>
                                        {this.state.rateEditable === idx
                                            ? <AmountInput name="value" value={this.state.editObj.value} size="sm" style={QTY_INPUT} onBlur={this.handleUpdateEditableItem.bind(this, 'blur')} onKeyPress={this.handleUpdateEditableItem.bind(this, 'key_press')} onChange={this.handleChangeEditableItem.bind(this)} />
                                            : '£ ' + formatAmount(ItemDetails.ItemRate)
                                        }
                                    </TableCell>
                                    <TableCell onDoubleClick={this.handleEditItems.bind(this, idx, 'ItemQuantity', ItemDetails.ItemQuantity)}>
                                        {this.state.quantityEditable === idx
                                            ? <Form.Control name="value" value={this.state.editObj.value} size="sm" type="number" style={QTY_INPUT} onBlur={this.handleUpdateEditableItem.bind(this, 'blur')} onKeyPress={this.handleUpdateEditableItem.bind(this, 'key_press')} onChange={this.handleChangeEditableItem.bind(this)} />
                                            : ItemDetails.ItemQuantity
                                        }
                                    </TableCell>
                                    <TableCell>{(ItemDetails.ItemDisc === '0' || ItemDetails.ItemDisc === 0) ? '' : (ItemDetails.ItemDisType === 'number' ? '£ ' + formatAmount(ItemDetails.ItemDisc) : '% ' + ItemDetails.ItemDisc)}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemAmount)}</TableCell>
                                    <TableCell>
                                        <IconButton size="small" onClick={this.handleRemove.bind(this, idx, ItemDetails)}><RemoveIcon /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={5} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Sale</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                <td />
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                        <Button variant="contained" onClick={this.handleSaveInvoice.bind(this)}>
                            {this.state.isEdit ? 'UPDATE' : 'SAVE'}
                        </Button>
                    </div>
                    {this.state.isEdit && (
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="tertiary" startIcon={<PrintIcon />}>PRINT INVOICE</Button>}
                            content={() => this.printAFSale}
                        />
                    )}
                </div>

                <SaleDeviceAF servedBy={this.state.servedBy}
                    ref={el => (this.printAFSale = el)}
                    jobData={{
                        FOR: 'Items',
                        INV_NUMBER: this.state.SALE_INV,
                        ITEM_LIST: this.state.AddedItemList,
                        SALE_TO: this.state.SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.label,
                        GRAND_TOTAL: this.renderTotalAmount()
                    }}
                />
            </Container>
        );
    }
}

export default withRouter(WarehouseItemSale);
